import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import { BgColor } from 'tbk-components/src/components/Core/colors';
import Image, { IImage } from 'tbk-components/src/components/Image';
import { ILink } from 'tbk-components/src/components/Button';

export interface Logo {
	url?: ILink;
	logo?: IImage;
}

export interface ILogoBarProps extends IBaseElementProps {
	heading?: string;
	backgroundColor?: BgColor;
	/**
	 * @size medium
	 */
	logos?: Logo[];
}

/**
 * URL Logo Bar
 * @block
 */

const UrlLogoBar: React.FC<ILogoBarProps> = ({
	heading,
	logos = [],
	className,
	backgroundColor,
	classNames = [],
}) => (
	<div
		className={
			className ||
			cn(
				'logo-bar',
				backgroundColor && `bg-${backgroundColor}`,
				...classNames,
			)
		}
	>
		{heading && <h2>{heading}</h2>}

		<div className="logo-bar__logos">
			{logos.map(({ logo, url }, i) => {
				return url && url.href ? (
					<a key={i} href={url.href} aria-label={url.label} target={url.target}>
						<Image {...logo}></Image>
					</a>
				) : (
					<Image key={i} {...logo}></Image>
				);
			})}
		</div>
	</div>
);

export default UrlLogoBar;
